module.exports = __webpack_public_path__ + "static/media/launch_beach_3.05cd06ed.svg";